// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2xdk2","content":"styles_content__1fYkM"};